import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, useTheme } from '@mui/material';

import { numberOrDash } from 'src/helper/helper';

interface TooltipContentProps {
  data: number[];
}

const TooltipContent: FC<TooltipContentProps> = ({ data }) => {
  const { t } = useTranslation('dashboard');
  const { colors } = useTheme();

  return (
    <Box>
      <Box component="span" sx={{ mr: 0.5 }}>
        {t('Answers.StronglyAgree')}:
      </Box>
      <Box component="span" sx={{ color: colors.doughnutVeryPositive }}>
        {numberOrDash(data[0], true)}
      </Box>
      <br />
      <Box component="span" sx={{ mr: 0.5 }}>
        {t('Answers.Agree')}:
      </Box>
      <Box component="span" sx={{ color: colors.doughnutPositive }}>
        {numberOrDash(data[1], true)}
      </Box>
    </Box>
  );
};

export default TooltipContent;
